import styled from 'styled-components';
import { media, vars } from '$util/theme';
import TopBackground from '$layout/partials/TopBackground';

export default styled(TopBackground)`
  padding: 50px 15px 40px 15px;
  text-align: center;
  ${media.up('md')} {
    min-height: 370px;
  }
  ${media.only('md')} {
    border-bottom: 1px solid ${vars.quantumverse.reskinColors.brandLightGray};
  }
  ${media.up('lg')} {
    background-position: 50% 100%;
    margin-bottom: 40px;
  }
`;
